<p-button
  type="button"
  styleClass="p-button-text p-button-sm"
  icon="pi pi-list"
  [label]="'' + count"
  [disabled]="count === 0"
  [pTooltip]="count ? 'Visualizza i seriali' : 'Nessun seriale associato'"
  tooltipPosition="top"
  (click)="open()"></p-button>

<p-dialog
  [header]="'Numeri seriali' + (title ? ' per ' + title : '')"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="visible"
  [style]="{ width: '40rem', maxWidth: '95vw' }">
  <div class="flex justify-content-end mb-2">
    <p-button
      styleClass="butt bg-white"
      [outlined]="false"
      [icon]="copied ? 'pi pi-check' : 'pi pi-copy'"
      label="Copia negli appunti"
      (click)="copy()"></p-button>
  </div>
  <p-table
    [value]="list"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="50vh">
    <ng-template pTemplate="header">
      <tr>
        <th>Seriale</th>
        <th>Codice asset</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-s>
      <tr>
        <td>{{ s.serial_number || '-' }}</td>
        <td>{{ s.asset_code || '-' }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
